export const SIDE_BAR_CLASS = '.b-eed-layout-sidebar';

export const MAIN_CONTENT_CLASS = '.b-eed-layout-main-content';